module.exports = __webpack_public_path__ + "media/images/emblems/Winkel-f446ec7bd61c9654c8b10f627f8d3e24.svg";